export default __webpack_public_path__ + "static/media/EM0860.34I-23051_-16367_0.8cf7d1ba.jpg";